import React, { forwardRef } from "react";
import OverflowingText from "../OverflowingText/OverflowingText";
import FilledButton from "../SelectButton/FilledButton";
import EmptyButton from "../SelectButton/EmptyButton";
import accessibleGoldenDropdown from "../Reports/AccessibleGoldenDropdown";

const CurrencyDropdown = forwardRef(
  (
    {
      OPTIONS,
      optionRefs,
      isOpen,
      list,

      showArrow,
      focusedIndex,
      selected,
      selectedIndex,
      headingValue,
      setHeadingValue,
      position,

      handleOptionKeyDown,
      selectOption,
      restrictHover,
      accessibilityValues,

      popupClassName = {
        open: "",
        close: "",
        wrapperClass: "",
        containerClass: "",
        popupMenuClass: "",
      },
      emailReport = () => {},
      exportAllExcel = () => {},
    },
    // ref,
  ) => {
    return (
      <div
        role={accessibilityValues.ariaHaspopup}
        id={accessibilityValues.ariaControls}
        aria-label={accessibilityValues.ariaLabel}
        className={`popup_menu ${popupClassName.popupMenuClass || ""}  ${
          showArrow === false ? "no_arrow" : ""
        } ${isOpen ? "popup_menu_open" : "popup_menu_close"}`}
        style={{ ...position }}
      >
        <div className="portfolio_report_accounts_container">
          {OPTIONS.map((listItem, index) => {
            const isSelected = selectedIndex === index;
            const isSelectedAccount = listItem[list.keyName] === headingValue;

            return (
              <div
                key={listItem[list.keyName]}
                ref={(el) => (optionRefs.current[index] = el)}
                role="radio"
                aria-checked={isSelected}
                tabIndex={focusedIndex === index ? 0 : -1}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    setHeadingValue(listItem);
                  }
                  handleOptionKeyDown(e, index);
                }}
                onClick={() => {
                  setHeadingValue(listItem);
                  selectOption(index);
                }}
                className="account_listitem cursor"
              >
                <div className="radio_btn_input">
                  {isSelectedAccount ? <FilledButton /> : <EmptyButton />}
                </div>
                <label
                  className="radio_btn_label cursor"
                  htmlFor={listItem[list.keyName]}
                >
                  <OverflowingText
                    text={listItem[list.keyName]}
                    width={160}
                    textClassName="radio_btn_label cursor_imp"
                    tooltipOnHover={true}
                    position="left"
                    tooltipClassName={
                      index === 0
                        ? "accounts_tooltip_styles_bottom"
                        : "accounts_tooltip_styles"
                    }
                  />
                </label>
              </div>
            );
          })}
        </div>
      </div>
    );
  },
);

export default accessibleGoldenDropdown(CurrencyDropdown);
